import React, { useEffect, useState } from "react";
import axios from "../../api/axiosInstance";
import '../../styles/CashFundCard.css';

// Helper to format currency
const formatCurrency = (num) =>
  num.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
  });

export const CashFundCard = ({ fund }) => {
  const [imgUrl, setImgUrl] = useState(null);
  const progress = Math.min(fund.receive_fund / fund.require_amount, 1);

  useEffect(() => {
    const fetchSignedImageUrl = async () => {
      if (!fund.imgUrl) return;
      try {
        const res = await axios.post("/v1/image/getSignedCashFundPicture", {
          key: fund.imgUrl,
        });

        if (res.data?.status === "success" && res.data.signedUrl) {
          setImgUrl(res.data.signedUrl);
        }
      } catch (error) {
        console.error("Failed to load image:", error);
        setImgUrl(null);
      }
    };

    fetchSignedImageUrl();
  }, [fund.imgUrl]);

  return (
    <div className="cash-fund-card">
      <div className="cash-fund-card__inner">
        <div className="cash-fund-card__content">
          {/* TITLE */}
          <div className="cash-fund-card__title">
            {fund.cash_fund_name || "Fund Name"}
          </div>

          {/* CHILD NAME & GOAL */}
          <div className="cash-fund-card__header">
            <span className="cash-fund-card__child-info">
              {fund.child_first_name ?? ""} {fund.child_last_name ?? ""},{" "}
              {fund.child_age != null ? `${fund.child_age} yrs old` : ""}
            </span>
            <span className="cash-fund-card__goal">
              Goal: <strong>{formatCurrency(fund.require_amount)}</strong>
            </span>
          </div>

          {/* DESCRIPTION */}
          <div className="cash-fund-card__description">
            {fund.description || "No description provided"}
          </div>

          {/* IMAGE PREVIEW */}
          <div className="cash-fund-card__image-container">
            <img
              src={
                imgUrl ||
                "https://placehold.co/200x150?text=Cash+Fund"
              }
              alt="Cash Fund"
              className="cash-fund-card__image"
            />
          </div>
        </div>

        {/* PROGRESS BAR */}
        <div className="cash-fund-card__progress-section">
          <div className="cash-fund-card__progress-bar">
            <div
              className="cash-fund-card__progress-fill"
              style={{ width: `${progress * 100}%` }}
            />
            <div
              className="cash-fund-card__progress-indicator"
              style={{ left: `${progress * 100}%` }}
            />
          </div>

          {/* Raised and Target Amount */}
          <div className="cash-fund-card__amounts">
            <span>{formatCurrency(fund.receive_fund)} Raised</span>
            <span>{formatCurrency(fund.require_amount)}</span>
          </div>
        </div>

        <div className="cash-fund-card__button-container">
          <button
            className="cash-fund-card__donate-button"
            onClick={() => alert("Redirect to payment page...")}
          >
            GIVE A LITTLE LOVE
          </button>
        </div>
      </div>
    </div>
  );
};
